/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * Web Dispatcher - spring-backend
 * API documentation for developers
 * OpenAPI spec version: 0.0.1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnniversaryChartJSON,
  ErrorDetails,
  PersonnelDimensionCountJSON
} from '../../model';

import { useCustomInstance } from '../../mutator/use-custom-instance.ts';
import type { ErrorType } from '../../mutator/use-custom-instance.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Count dimension items in use by personnel
 * @summary Get personnel dimensions count
 */
export const getPersonnelDimensions = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<PersonnelDimensionCountJSON[]>(
      {url: `/api/v1/rest/charts/personnelcount`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonnelDimensionsQueryKey = () => {
    return [
    `/api/v1/rest/charts/personnelcount`
    ] as const;
    }


export const getGetPersonnelDimensionsQueryOptions = <TData = Awaited<ReturnType<typeof getPersonnelDimensions>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonnelDimensions>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonnelDimensionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonnelDimensions>>> = ({ signal }) => getPersonnelDimensions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonnelDimensions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonnelDimensionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonnelDimensions>>>
export type GetPersonnelDimensionsQueryError = ErrorType<ErrorDetails>


export function useGetPersonnelDimensions<TData = Awaited<ReturnType<typeof getPersonnelDimensions>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonnelDimensions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonnelDimensions>>,
          TError,
          Awaited<ReturnType<typeof getPersonnelDimensions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonnelDimensions<TData = Awaited<ReturnType<typeof getPersonnelDimensions>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonnelDimensions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonnelDimensions>>,
          TError,
          Awaited<ReturnType<typeof getPersonnelDimensions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonnelDimensions<TData = Awaited<ReturnType<typeof getPersonnelDimensions>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonnelDimensions>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get personnel dimensions count
 */

export function useGetPersonnelDimensions<TData = Awaited<ReturnType<typeof getPersonnelDimensions>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonnelDimensions>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonnelDimensionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch list of persons from database
 * @summary Get anniversary chart
 */
export const getActivePersons = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<AnniversaryChartJSON[]>(
      {url: `/api/v1/rest/charts/anniversary`, method: 'GET', signal
    },
      options);
    }




export const getGetActivePersonsQueryKey = () => {
    return [
    `/api/v1/rest/charts/anniversary`
    ] as const;
    }


export const getGetActivePersonsQueryOptions = <TData = Awaited<ReturnType<typeof getActivePersons>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePersons>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivePersonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivePersons>>> = ({ signal }) => getActivePersons(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivePersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivePersonsQueryResult = NonNullable<Awaited<ReturnType<typeof getActivePersons>>>
export type GetActivePersonsQueryError = ErrorType<ErrorDetails>


export function useGetActivePersons<TData = Awaited<ReturnType<typeof getActivePersons>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivePersons>>,
          TError,
          Awaited<ReturnType<typeof getActivePersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivePersons<TData = Awaited<ReturnType<typeof getActivePersons>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivePersons>>,
          TError,
          Awaited<ReturnType<typeof getActivePersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivePersons<TData = Awaited<ReturnType<typeof getActivePersons>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePersons>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get anniversary chart
 */

export function useGetActivePersons<TData = Awaited<ReturnType<typeof getActivePersons>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivePersons>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivePersonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






